import React, { useRef, useState } from "react";
import RolesAndPermissions from "./RolesAndPermissions";
import { STATUS_CODE } from "common/Constants";
import { Form, message, Modal, Radio } from "antd";
import { connect, useSelector } from "react-redux";
import { getClientid, getUserInfo, getUserList } from "redux/selectors";
import { CALL_API } from "common/API";
import styled from "styled-components";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { setMenuList, setRoleList, setUserList } from "redux/actions";
import { bindActionCreators } from "redux";
import { ExclamationCircleFilled } from "@ant-design/icons";
import SuccessPopup from "./SuccessPopup";

const EditPermissionWrapp = styled.div`
  position: relative;
  height: calc(100vh - 150px);
`;

const EditPermission = ({
  details,
  setIsEditPermission,
  getRoleList,
  saveRoleList,
  updateUserList,
  saveMenuList,
}) => {
  const userInfo = useSelector(getUserInfo);
  const clientId = useSelector(getClientid);
  const userList = useSelector(getUserList);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const containerRef = useRef();
  const [successModal, setSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const showChangeConfirm = (menuList) => {
    Modal.confirm({
      title: "",
      icon: null,
      content: (
        <>
          <div className="text-center">
            <ExclamationCircleFilled
              style={{
                fontSize: 44,
                color: "#2D53DA",
                marginBottom: 16,
                display: "inline-block",
              }}
            />
          </div>
          <Form
            form={form}
            name="applyall"
            layout="vertical"
            initialValues={{ applyall: "Default" }}
          >
            <Form.Item
              className="pb-0 mb-0"
              name="applyall"
              label="You want to apply the changes for"
              rules={[
                {
                  required: false,
                  message: "Please Select",
                },
              ]}
            >
              <Radio.Group
                placeholder="Radio.Group"
                getPopupContainer={() => containerRef.current}
              >
                <Radio value="Custom">Upcoming employees</Radio>
                <Radio value="Default">
                  All existing employees and override any individual settings
                  which was made before.
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Form>
        </>
      ),
      okText: "Save Changes",
      cancelText: "Cancel",
      okButtonProps: {
        loading: loading,
      },
      onOk: async () => {
        handleChange(menuList);
      },
    });
  };

  const fetchMasterData = async (fetch_master_data) => {
    const { code, roleList, userList, menuList, userrole } = await CALL_API(
      `master-data/${clientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      if (fetch_master_data) {
        if (userrole === "Owner") {
          saveMenuList(menuList);
        } else {
          saveMenuList(
            userList?.find((user) => user?.userid === userInfo?.userid)
              ?.menulist
          );
        }
        saveRoleList(roleList);
        updateUserList(userList);
      }
    }
  };

  const updateChangeRole = async (record, menuList) => {
    setLoading(true);
    const { code, response } = await CALL_API(
      `add-users/change-role`,
      "patch",
      {
        userids: userList
          ?.filter((val) => val?.roleid?.includes(record?.roleId))
          ?.map((item) => item?.userid),
        roleid: record?.roleId,
        permissiontype: form.getFieldValue("applyall"),
        custommenulist:
          form.getFieldValue("applyall") === "Default" ? menuList : [],
        currentroleid: details?.roleId,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      fetchMasterData(true);
      setLoading(false);
    } else {
    }
  };

  const handleChange = async (menuList) => {
    setLoading(true);
    const { code } = await CALL_API(
      `owner-roles/${clientId}/${details.roleId}`,
      "patch",
      {
        rolename: details?.roleName,
        department: details.department || [],
        location: details?.locationId || [],
        menuList: menuList,
        rolestatus: details?.roleStatus,
        statusId: details?.statusId,
        applyall: form.getFieldValue("applyall"),
      }
    );
    if (STATUS_CODE.SUCCESS === code) {
      updateChangeRole(details, menuList);
      setSuccessModal(true);
      setSuccessMessage("Saved");

      getRoleList();
      setTimeout(() => {
        setSuccessModal(false);
        setSuccessMessage("");
        setIsEditPermission(false);
      }, 3000);
    }
    setLoading(false);
  };

  const onFinish = (menuList) => {
    showChangeConfirm(menuList);
  };

  return (
    <EditPermissionWrapp>
      <label
        className="bg-transparent border-0 mb-3 text-left styled-cursor"
        onClick={() => setIsEditPermission(false)}
      >
        Role - Permission <ArrowForwardIosIcon className="px-1" />
      </label>{" "}
      <label
        className="bg-transparent border-0 mb-3 text-left styled-cursor"
        onClick={() => setIsEditPermission(false)}
      >
        {details?.roleName} <ArrowForwardIosIcon className="px-1" />
      </label>{" "}
      <b className="pb-0 pt-1">Editing Role</b>
      <div>
        <RolesAndPermissions
          menuList={details?.menuList}
          setsubmit={() => {}}
          onFinish={onFinish}
          loading={loading}
          type="edit"
          handleCancel={setIsEditPermission}
        />
      </div>
      <SuccessPopup
        open={successModal}
        close={setSuccessModal}
        text={successMessage}
      />
    </EditPermissionWrapp>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveMenuList: setMenuList,
      updateUserList: setUserList,
      saveRoleList: setRoleList,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps, null)(EditPermission);
